<!-- <p>incident-timeline-serial-graph works!</p> -->
<div class="demo-chart-wrapper">
  <div class="center-wrap">
    <div class="chart-scroll-container">
      <div
        echarts
        [options]="chartOptions"
        [ngStyle]="
          height
            ? { height: height, width: getChartWidth() }
            : { width: getChartWidth() }
        "
        class="demo-chart"
      ></div>
    </div>
  </div>
</div>
